/**
 * Capitalized every first character of word
 * https://github.com/ziishaned/learn-regex
 * https://stackoverflow.com/a/17200679/8680724
 */
function capitalized(text) {
    return text.toLowerCase().replace(/\b[a-z](?=[a-z]{2})/g, (letter) => {
        return letter.toUpperCase();
    });
}
export function enumValueNormalizer(value) {
    const normalizedText = value.replace(/_/g, ' ');
    return capitalized(normalizedText);
}
